import { Card, CardBody } from "reactstrap"
import MoneyReceiptHeader from "./MoneyReceipt/MoneyReceiptHeader"
import MoneyReceiptList from "./MoneyReceipt/MoneyReceiptList"

export default function MoneyReceiptsTab({ customer, onChanged }) {
  const receipts = customer?.money_receipts || []
  const total = receipts.length ?? 0

  return (
    <Card className="border-0 shadow-sm">
      <CardBody className="p-4">
        <MoneyReceiptHeader total={total} customer={customer} />
        <MoneyReceiptList data={receipts} onChanged={onChanged} />
      </CardBody>
    </Card>
  )
}
